import { render, staticRenderFns } from "./virtualPrize.vue?vue&type=template&id=11f401be"
import script from "./virtualPrize.vue?vue&type=script&lang=js"
export * from "./virtualPrize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports